import React from 'react';
import moment from 'moment';
import * as R from 'ramda';

import {prettyDollars} from 'js/common/string_helper';

const formatDate = d => moment(d).format('MMM D, YYYY');

const CampaignDetails = ({
    productDescription,
    productName,
    productRetailCost,
    hashtags,
    screenNames,
    hideScreenNames,
    startDate,
    endDate,
    productAvailabilities,
    productIsRequired
}) => {

    const productNameVal = productName || 'N/A';
    const productDescriptionVal = productDescription || 'N/A';
    const productRetailCostVal = productRetailCost ? prettyDollars(productRetailCost, 2) : 'N/A';

    const hashtagsVal = hashtags
            ? R.pipe(R.split(','), R.map(R.concat('#')), R.join(', '))(hashtags)
            : 'N/A';

    const displayScreenNames = () => {
        if (hideScreenNames) {
            return null;
        }
        const screenNamesVal = screenNames
            ? R.pipe(
                R.split(','),
                R.map(screenName =>
                    screenName.charAt(0) !== '@' ? `@${screenName}` : screenName
                ),
                R.join(', ')
            )(screenNames)
            : 'N/A';

        return screenNamesVal;
    };

    const productAvailabilitiesVal =
        Array.isArray(productAvailabilities) && productAvailabilities.length > 0
            ? productAvailabilities.join(', ')
            : 'N/A';

    return (
        <div className="detail-section">
            <div className="detail-section-title">
                <h5>Campaign details</h5>
            </div>

            <div className="detail-section-grid">
                <div className="detail-section-grid-item">
                    <p className="content-section-title -no-margin">Meta Partnership Ad</p>
                    <div className="item-value">TBD</div>
                </div>

                <div className="detail-section-grid-item">
                    <p className="content-section-title -no-margin">TikTok Spark Ad</p>
                    <div className="item-value">TBD</div>
                </div>

                <div className="detail-section-grid-item">
                    <p className="content-section-title -no-margin">Required Hashtags</p>
                    <div className="item-value">{hashtagsVal}</div>
                </div>

                <div className="detail-section-grid-item">
                    <p className="content-section-title -no-margin">Required Tagged Handles</p>
                    <div className="item-value">{displayScreenNames()}</div>
                </div>

                <div className="detail-section-grid-item">
                    <p className="content-section-title -no-margin">Creators begin posting on</p>
                    <div className="item-value">{formatDate(startDate)}</div>
                </div>

                <div className="detail-section-grid-item">
                    <p className="content-section-title -no-margin">All creators have posted by</p>
                    <div className="item-value"> {formatDate(endDate)}</div>
                </div>

                <div className="detail-section-grid-item">
                    <p className="content-section-title -no-margin">Product Required</p>
                    <div className="item-value">{productIsRequired ? 'Yes' : 'No'}</div>
                </div>

                <div className="detail-section-grid-item">
                    <p className="content-section-title -no-margin">Product Availability</p>
                    <div className="item-value">{productAvailabilitiesVal}</div>
                </div>

                <div className="detail-section-grid-item">
                    <p className="content-section-title -no-margin">Product Name</p>
                    <div className="item-value">{productNameVal}</div>
                </div>

                <div className="detail-section-grid-item">
                    <p className="content-section-title -no-margin">Retail Price</p>
                    <div className="item-value">{productRetailCostVal}</div>
                </div>

                <div className="detail-section-grid-item -item-span-2">
                    <p className="content-section-title -no-margin">Product Description</p>
                    <div className="item-value item-product-description">{productDescriptionVal}</div>
                </div>
            </div>
        </div>
    );
};

export default CampaignDetails;



// WEBPACK FOOTER //
// ./components/verify_receipt_common/campaign_details.js